module.exports = __webpack_public_path__ + "assets/img/travel-day15.f4a7ee46.png";